import { useMemo } from "react";
import { ethers } from "ethers";
import { useWeb3 } from "../context/Web3Context";
import {
  NETWORK,
  TOKEN_ABI,
  DATA_ABI,
  PLAN1_ABI,
  PLAN2_ABI,
} from "../config/config";

export function useContract() {
  const { signer, provider } = useWeb3();

  const contracts = useMemo(() => {
    const signerOrProvider = signer || provider;
    if (!signerOrProvider) return null;

    const { token, data, plan1, plan2 } = NETWORK.contracts;
    if (!token || !data || !plan1 || !plan2) return null;

    return {
      token: new ethers.Contract(token, TOKEN_ABI, signerOrProvider),
      data: new ethers.Contract(data, DATA_ABI, signerOrProvider),
      plan1: new ethers.Contract(plan1, PLAN1_ABI, signerOrProvider),
      plan2: new ethers.Contract(plan2, PLAN2_ABI, signerOrProvider),
    };
  }, [signer, provider]);

  return contracts;
}
